<app-roomchampions
  [roomChampions]="(roomchampions$ | async)!"
  [loading]="!!(loading$ | async)"
  [theme]="theme"
></app-roomchampions>
